import BancosPage from '@/pages/Administracion/BancosValores/BancosPage.jsx';

export default function CuentasBancariasPage() {
  return <BancosPage accountsOnly />;
}
